module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_9016.9731969b.png";